import { render, staticRenderFns } from "./NsipsDetail.vue?vue&type=template&id=89601eea&"
import script from "./NsipsDetail.vue?vue&type=script&lang=js&"
export * from "./NsipsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports